<template>
  <span class="relative flex h-4 w-4 justify-center">
    <i-mdi-share
      class="absolute -right-0.5 -top-1 h-4 w-4 stroke-white stroke-1 text-entry-green-darker"
    ></i-mdi-share>
    <svg
      v-if="filled"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196 240"
      data-pw="schema-icon-focus"
    >
      <rect
        x="9"
        y="37"
        width="178"
        height="194"
        rx="29"
        ry="29"
        class="fill-current stroke-current"
        :class="[primaryColor]"
        stroke-width="18"
      />
      <path
        d="m71.04,18c.74-10.03,12.53-18,26.96-18s26.22,7.97,26.96,18h15.04v39H57V18h14.04Zm32.96-6c0,3.31-2.69,6-6,6s-6-2.69-6-6,2.69-6,6-6,6,2.69,6,6Zm-40,82c0,6.07-4.92,11-11,11s-11-4.93-11-11,4.92-11,11-11,11,4.92,11,11Zm0,34c0,6.07-4.92,11-11,11s-11-4.93-11-11,4.92-11,11-11,11,4.93,11,11Zm-11,45c6.08,0,11-4.93,11-11s-4.92-11-11-11-11,4.93-11,11,4.92,11,11,11Zm24-85h76v14h-76v-14Zm76,34h-76v14h76v-14Zm-76,34h76v14h-76v-14Z"
        class="fill-current stroke-none"
        :class="[secondaryColor]"
        fill-rule="evenodd"
        stroke-width="18"
      />
    </svg>

    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196 240"
      data-pw="schema-icon"
    >
      <rect
        x="9"
        y="37"
        width="178"
        height="194"
        rx="29"
        ry="29"
        class="fill-white stroke-current"
        stroke-width="18"
        :class="primaryColor"
      />
      <path
        d="m71.04,18c.74-10.03,12.53-18,26.96-18s26.22,7.97,26.96,18h15.04v39H57V18h14.04Zm32.96-6c0,3.31-2.69,6-6,6s-6-2.69-6-6,2.69-6,6-6,6,2.69,6,6Zm-40,82c0,6.07-4.92,11-11,11s-11-4.93-11-11,4.92-11,11-11,11,4.92,11,11Zm0,34c0,6.07-4.92,11-11,11s-11-4.93-11-11,4.92-11,11-11,11,4.93,11,11Zm-11,45c6.08,0,11-4.93,11-11s-4.92-11-11-11-11,4.93-11,11,4.92,11,11,11Zm24-85h76v14h-76v-14Zm76,34h-76v14h76v-14Zm-76,34h76v14h-76v-14Z"
        class="fill-current stroke-none"
        :class="primaryColor"
        fill-rule="evenodd"
        stroke-width="18"
      />
    </svg>
  </span>
</template>
<script setup lang="ts">
import type { EntryColor } from "~/models/IEntryColor";

const props = withDefaults(
  defineProps<{
    colorClass: EntryColor | "own";
    filled?: boolean;
  }>(),
  {
    filled: false,
  }
);

const colorMapPrimary = {
  yellow: "text-entry-yellow-darker",
  orange: "text-entry-orange-darker",
  red: "text-entry-red-darker",
  purple: "text-entry-purple-darker",
  blue: "text-entry-blue-default",
  green: "text-entry-green-darker",
  own: "text-schema-own-darker",
};

const colorMapSecondary = {
  yellow: "text-entry-yellow-lightest",
  orange: "text-entry-orange-lighter",
  red: "text-entry-red-lighter",
  purple: "text-entry-purple-lighter",
  blue: "text-entry-blue-lighter",
  green: "text-entry-green-lighter",
  own: "text-schema-own-lighter",
};

const primaryColor = computed(() => colorMapPrimary[props.colorClass]);
const secondaryColor = computed(() => colorMapSecondary[props.colorClass]);
</script>
